/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

// This file was ported from WebSDK/src/sdk/audio/AudioSpeakerDetector.js

import AudioVolumeMeterFactory from './AudioVolumeMeterFactory';
import AudioSpeakerDetectionAlgorithm from './AudioSpeakerDetectionAlgorithm';

class AudioSpeakerDetector {
  constructor(userMediaStreams) {
    this._nativeAudioContext = new AudioContext();
    this._onSpeakingChanged = null;
    this._userMediaStreams = userMediaStreams;
    this._audioVolumeMeterFactory = new AudioVolumeMeterFactory();

    this._userMediaStreams.forEach(stream => this._setupAudioVolumeMeter({}, stream));
  }

  start(options = {}, callback) {
    this._onSpeakingChanged = callback;
    this._userMediaStreams.forEach(stream => this._setupSpeakingDetection(options, stream));
  }

  stop() {
    this.getAudioVolumeMeters().forEach(meter => {
      meter.onValue(() => {});
    });

    this._onSpeakingChanged = null;
  }

  getAudioVolumeMeter(stream) {
    return this._audioVolumeMeterFactory.getAudioVolumeMeter(stream);
  }

  getAudioVolumeMeters() {
    return this._audioVolumeMeterFactory.getAudioVolumeMeters();
  }

  dispose() {
    this._nativeAudioContext.close();
    this._audioVolumeMeterFactory.stopAllMeters();
    this._userMediaStreams = null;
  }

  _setupAudioVolumeMeter(options, stream) {
    const audioVolumeMeter = this._audioVolumeMeterFactory.getAudioVolumeMeter(stream);

    audioVolumeMeter.init(this._nativeAudioContext, options.alpha);
    audioVolumeMeter.connect(stream);
  }

  _setupSpeakingDetection(options, stream) {
    const audioVolumeMeter = this._audioVolumeMeterFactory.getAudioVolumeMeter(stream);
    const audioSpeakerDetectionAlgorithm = new AudioSpeakerDetectionAlgorithm();

    if (options.alpha) {
      audioVolumeMeter.setAlpha(options.alpha);
    }

    audioSpeakerDetectionAlgorithm.onValue(this._onSpeakingChanged);
    audioSpeakerDetectionAlgorithm.startDetection(audioVolumeMeter, options);
  }
}

export default AudioSpeakerDetector;